import { render, staticRenderFns } from "./DashboardSideMenu.vue?vue&type=template&id=b5662116&scoped=true&"
import script from "./DashboardSideMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSideMenu.vue?vue&type=style&index=0&id=b5662116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5662116",
  null
  
)

export default component.exports